module.exports = __webpack_public_path__ + "img/layout-desktop-fg.607e97d5.png";